import React, { useState } from "react";
import "../resources/LogInPage.css"; // Import CSS for styling
import FullLogo from "../resources/Artiq2.png";
import { notify, Toast } from "../components/Toast/Toast";

export function LogInPage(props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [forgotten, setForgotten] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleLoginClick = () => {
    if (!email || !password) {
      setMessage("Please enter both email and password");
      return;
    }

    fetch("https://inventy.redata.se/inventdb/api_login.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.success) {
          setMessage("Login successful");
          localStorage.setItem("UserID", data.id);
          localStorage.setItem("email", email);
          localStorage.setItem("Name", data.name);
          localStorage.setItem("Admin", data.Admin);
          localStorage.setItem("token", data.token);
          localStorage.setItem("Expire", "" + Date.now());
          props.setUser(data);
        } else {
          setMessage(data.message);
          notify("error", data.message)
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setMessage("An error occurred while logging in");
      });
  };

  function sendCode() {
    fetch("https://inventy.redata.se/inventdb/api_recoverPassword.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ command: "sendCode", email }),
    })
      .then((response) => response.json())
      .then((data) => {
        setMessage(data.message);
        setSuccess(data.success);
      })
      .catch((error) => {
        console.error("Error:", error);
        setMessage("An error occurred while logging in");
      });
  }

  return (
    <div className="login-container">
      <img src={FullLogo} alt="Inventory Manager" width="70%" />
      {forgotten ? (
        <>
          <h2 style={{ color: "var(--background-color)" }}>
            Återställ lösenord
          </h2>
          <div className="input-field">
            <input
              type="text"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <button className="login-button" onClick={sendCode}>
            Skicka länk
          </button>
          <div className="message" style={success ? { color: "white" } : {}}>
            {message}
          </div>
        </>
      ) : (
        <>
          <h2 style={{ color: "var(--background-color)" }}>Login</h2>
          <div className="input-field">
            <input
              type="text"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="input-field">
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  handleLoginClick();
                }
              }}
            />
          </div>
          <button className="login-button" onClick={handleLoginClick}>
            Logga in
          </button>
          <p
            style={{ color: "var(--block)", marginTop: "10px" }}
            onClick={() => setForgotten(true)}
          >
            Glömt lösenord
          </p>
          <div className="message">{message}</div>
        </>
      )}
      <Toast/>
    </div>
  );
}
